import React, { useEffect } from "react";
import styled from "styled-components";
import { useTimeout } from "@sonder/ui/source/hooks/useTimeout";
import { Bell, X } from "@sonder/ui/source/icons";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { Toast } from "@sonder/ui/source/styled/fragments/Toast";
import { useSegment } from "analytics/segment";
import { useStore as useAuthStore } from "auth/store";
import { FIFTEEN_SECONDS } from "core/constants";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { useManageUser } from "core/queries/ManageUser";
import { UndoAction, removeUndo } from "team/actions";
import { useStore as useTeamStore } from "team/store";

const Message = styled.span`
  margin: 0 1rem;
`;

export const UndoToast = () => {
  const errorReporter = useErrorReporterFiltered();
  const { track } = useSegment();

  const { state: authState } = useAuthStore();
  const cityId = authState.user?.cityId;
  const {
    dispatch,
    state: { undo },
  } = useTeamStore();

  const stubVariables = {
    cityId: null,
    userId: "",
  };
  const [manageUser] = useManageUser({
    awaitRefetchQueries: true,
    refetchQueries: ["GetTeam"],
    variables: stubVariables,
  });

  const action = undo?.action;
  const userId = undo?.user?.id;
  const userName = undo?.user?.name;

  const { start } = useTimeout(
    () => userId && dispatch(removeUndo()),
    FIFTEEN_SECONDS,
  );
  useEffect(() => {
    if (userId) start();
  }, [userId]);
  if (!action || !cityId || !userId) return null;

  const onUndoClick = async () => {
    track({
      eventName: "team_undo_toast",
      element: "undo_button",
      action: "click",
      props: { action, userId },
    });

    try {
      const variables = {
        userId,
        cityId: action === UndoAction.ADD_MEMBER ? null : cityId,
      };
      const response = await manageUser({ variables });
      const mutatedUser = response.data?.manageUser?.user;
      if (mutatedUser) dispatch(removeUndo());
    } catch (error) {
      errorReporter.notify(error);
    }
  };

  const actionText =
    action === UndoAction.ADD_MEMBER ? "added to" : "removed from";
  const message = `${userName} was ${actionText} the team.`;

  return (
    <Toast>
      <Bell />
      <Message>{message}</Message>
      <PrimaryButton onClick={onUndoClick}>Undo</PrimaryButton>
      <CircleButton
        backgroundVariant="dark"
        onClick={() => {
          dispatch(removeUndo());
          track({
            eventName: "team_undo_toast",
            element: "dismiss_button",
            action: "click",
            props: { userId },
          });
        }}
      >
        <X />
      </CircleButton>
    </Toast>
  );
};
